import addMount from "../../core/addMount";
import Reader from "./Reader.entry";

addMount({ appName: "reader", app: Reader });
